"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HandleClick = exports.FormatToCurrencyInt = exports.Dial = exports.CalculateRotation = void 0;
var LearnMoreMethods = _interopRequireWildcard(require("./LearnMoreEarnMore"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tabs = _interopRequireDefault(require("../Tabs/Tabs"));
var _function = require("../../utils/type-checks/function");
var _number = require("../../utils/type-checks/number");
var _object = require("../../utils/type-checks/object");
var _string = require("../../utils/type-checks/string");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Learn More Earn More
 *
 * @visibleName Component Template
 * @author Tanner Williams
*/

const merge = require("deepmerge"),
  CalculateRotation = (salary, minSalary, maxSalary, customAngleRange) => {
    const angleRange = (0, _number.isNumber)(customAngleRange) ? Math.round(parseFloat(customAngleRange)) : 180;
    let salaryRange,
      rotationPerDollar,
      rotation,
      result = 0;
    if ((0, _number.isNumber)(salary) && (0, _number.isNumber)(minSalary) && (0, _number.isNumber)(maxSalary) && minSalary < maxSalary && salary >= minSalary && salary <= maxSalary) {
      salaryRange = maxSalary - minSalary;
      /* calculating the rotation per dollar */
      rotationPerDollar = angleRange / salaryRange;
      /* find out how far the salary is from the minsalary then multiply by rotation per dollar */
      rotation = (salary - minSalary) * rotationPerDollar;

      /* dont return anything smaller than 0 and nothing bigger than 180 for the rotation */
      result = Math.min(Math.max(0, rotation), angleRange);
    }
    return result;
  },
  FormatToCurrencyInt = value => {
    const reFormat = /(\d+)(\d{3})/;
    let result = "0";
    if ((0, _number.isNumber)(value)) {
      result = Math.round(value).toString();

      // Iterate until the pattern matching fails;
      while (reFormat.test(result)) {
        // Set return to itself, adding comma between matching groups;
        result = result.replace(reFormat, `${RegExp.$1},${RegExp.$2}`);
      }
    }
    result = "$" + result;
    return result;
  },
  HandleClick = (e, obj, setter) => {
    const tabId = (0, _object.isObject)(e) && (0, _object.isObject)(e.target) && (0, _function.isFunction)(e.target.getAttribute) && (0, _string.isStringOfLength)(e.target.getAttribute("data-tab-id")) ? e.target.getAttribute("data-tab-id") : null;
    let result = null;
    if ((0, _object.isObject)(obj) && (0, _string.isStringOfLength)(obj[tabId]) && (0, _function.isFunction)(setter)) {
      result = obj[tabId];
      setter(obj[tabId]);
    }
    return result;
  },
  Dial = props => {
    const {
        customStyles = {},
        customTheme = {},
        maxSalary = 110000,
        minSalary = 10000,
        salary,
        testId,
        timeDelay = 250
      } = props,
      theme = merge((0, _styles.useTheme)(), customTheme),
      [rotationAngle, setRotationAngle] = (0, _react.useState)(0),
      salaryNumber = parseFloat(salary.replace(/[^\d.]/gi, "")),
      compositeStyles = merge({
        background: "#EAECEF",
        pointer: "#000000",
        segmentOne: "#438C1D",
        segmentTwo: "#97CD7B",
        segmentThree: "#67AA44"
      }, customStyles);
    (0, _react.useLayoutEffect)(() => {
      const timer = setTimeout(() => {
        const rotationForSalary = CalculateRotation(salaryNumber, minSalary, maxSalary);
        setRotationAngle(rotationForSalary);
      }, timeDelay);
      return () => clearTimeout(timer);
    }, [maxSalary, minSalary, salaryNumber, timeDelay]);
    return /*#__PURE__*/_react.default.createElement(_material.Typography, {
      component: "figure",
      "data-testid": testId,
      sx: {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        marginBottom: {
          xs: "2rem",
          md: 0
        }
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      component: "div",
      role: "img",
      "aria-label": `Graph illustrating that the salary of ${FormatToCurrencyInt(salaryNumber)} lies approximately ${Math.round(rotationAngle / 180 * 100)}% between a range of ${FormatToCurrencyInt(minSalary)} and ${FormatToCurrencyInt(maxSalary)}`,
      sx: {
        maxWidth: "41.3rem",
        width: {
          sm: "100%",
          md: "41.3rem"
        },
        svg: {
          height: "auto",
          width: "100%"
        },
        "#Pointer,#Wipe": {
          transformOrigin: "center 87.55364806866953%",
          transform: `rotate(${rotationAngle}deg)`,
          transition: "transform 1s ease-out"
        },
        ".st0": {
          fill: compositeStyles.segmentOne
        },
        ".st1": {
          fill: compositeStyles.segmentTwo
        },
        ".st2": {
          fill: compositeStyles.segmentThree
        },
        ".st3": {
          fill: "white"
        },
        ".st4": {
          fill: compositeStyles.background,
          stroke: compositeStyles.background,
          strokeMiterlimit: "10"
        },
        ".st5": {
          fill: "#5F6061",
          fontFamily: "OpenSans-Regular",
          fontSize: "15px"
        }
      }
    }, /*#__PURE__*/_react.default.createElement("svg", {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      viewBox: "0 0 413 233"
    }, /*#__PURE__*/_react.default.createElement("g", {
      id: "Arch"
    }, /*#__PURE__*/_react.default.createElement("path", {
      id: "Path_00000153693331977680003640000006805737586950680214_",
      "data-testid": `${testId}--st0`,
      className: "st0",
      d: "M408.4,203.7c0-53.6-21.3-105.1-59.2-143 c-37.9-37.9-89.4-59.2-143-59.2c-53.6,0-105.1,21.3-143,59.2c-37.9,37.9-59.2,89.4-59.2,143h50.6c0-40.2,16-78.8,44.4-107.3 c28.4-28.4,67-44.4,107.3-44.4S285,68,313.4,96.5c28.4,28.4,44.4,67,44.4,107.3H408.4z"
    }), /*#__PURE__*/_react.default.createElement("path", {
      id: "Path_00000054262757543356145580000006556681574614194870_",
      "data-testid": `${testId}--st1`,
      className: "st1",
      d: "M108.2,26.5C76.5,44,50.1,69.7,31.8,101 c-18.3,31.2-28,66.8-27.9,103l50.6-0.2c-0.1-27.2,7.1-53.9,20.9-77.3c13.8-23.4,33.6-42.7,57.3-55.9L108.2,26.5z"
    }), /*#__PURE__*/_react.default.createElement("path", {
      id: "Path_00000166670541564322741090000008537742422465910449_",
      "data-testid": `${testId}--st2`,
      className: "st2",
      d: "M307.3,28.6C276.6,10.9,241.8,1.5,206.4,1.5 c-35.4,0-70.2,9.2-100.9,26.8l25.2,43.9c23-13.2,49.1-20.2,75.7-20.1c26.6,0,52.6,7,75.7,20.3L307.3,28.6z"
    })), /*#__PURE__*/_react.default.createElement("g", {
      id: "Wipe",
      "data-testid": `${testId}--isWipe`
    }, /*#__PURE__*/_react.default.createElement("rect", {
      x: "0",
      y: "1.2",
      className: "st3",
      width: "413",
      height: "202.8"
    }), /*#__PURE__*/_react.default.createElement("path", {
      id: "Path_00000106834966194236234300000012752665699231971214_",
      "data-testid": `${testId}--st4`,
      className: "st4",
      d: "M408.8,203.4c0-53.6-21.3-105.1-59.2-143 c-37.9-37.9-89.4-59.2-143-59.2c-53.6,0-105.1,21.3-143,59.2c-37.9,37.9-59.2,89.4-59.2,143h50.6c0-40.2,16-78.8,44.4-107.3 c28.4-28.4,67-44.4,107.3-44.4s78.8,16,107.3,44.4c28.4,28.4,44.4,67,44.4,107.3H408.8z"
    })), /*#__PURE__*/_react.default.createElement("g", {
      id: "Mask"
    }, /*#__PURE__*/_react.default.createElement("rect", {
      x: "1",
      y: "204",
      className: "st3",
      width: "412",
      height: "29"
    })), /*#__PURE__*/_react.default.createElement("g", {
      id: "Pointer",
      "data-testid": `${testId}--isPointer`
    }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("circle", {
      cx: "206.5",
      cy: "204",
      r: "11.2",
      fill: compositeStyles.pointer,
      "data-testid": `${testId}--isCircle`
    }), /*#__PURE__*/_react.default.createElement("polyline", {
      points: "206.5,192.9 38.7,203.9 206.5,215.2 206.2,194.2",
      fill: compositeStyles.pointer
    }))), /*#__PURE__*/_react.default.createElement("g", {
      id: "Text"
    }, /*#__PURE__*/_react.default.createElement("text", {
      transform: "matrix(1 0 0 1 2.441406e-04 228.4904)",
      className: "st5"
    }, FormatToCurrencyInt(minSalary)), /*#__PURE__*/_react.default.createElement("text", {
      transform: "matrix(1 0 0 1 348.7192 228.4904)",
      className: "st5"
    }, FormatToCurrencyInt(maxSalary))))), /*#__PURE__*/_react.default.createElement(_material.Box, {
      component: "figcaption",
      sx: {
        display: "block",
        textAlign: "center",
        "strong": {
          display: "block",
          fontSize: "2.6rem",
          fontFamily: theme.fontFamilies.bold
        },
        ".heading--isInteriorPageHeading": {
          fontSize: "1.5rem !important",
          marginBottom: "0.5rem",
          color: "#3B4557 !important"
        }
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      component: "h2",
      className: "heading--isInteriorPageHeading"
    }, "Annual Salary"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      component: "strong"
    }, " $", salary)));
  };
exports.Dial = Dial;
exports.HandleClick = HandleClick;
exports.FormatToCurrencyInt = FormatToCurrencyInt;
exports.CalculateRotation = CalculateRotation;
const LearnMoreEarnMore = props => {
  const {
      dataArray,
      customDial = {},
      customInstanceString,
      customStyles = {},
      customTheme = {},
      testId
    } = props,
    [salary, setSalary] = (0, _react.useState)(dataArray[0]?.salary || "$0"),
    [degreesToSalaries, setDegreesToSalaries] = (0, _react.useState)({});
  (0, _react.useEffect)(() => {
    dataArray.forEach(item => {
      setDegreesToSalaries(prevState => ({
        ...prevState,
        [item.customId || item.fragmentId]: item.salary
      }));
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    "data-testid": testId,
    sx: customStyles
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    onClick: e => LearnMoreMethods.HandleClick(e, degreesToSalaries, setSalary)
  }, /*#__PURE__*/_react.default.createElement(_Tabs.default, {
    customInstanceString: customInstanceString,
    styles: {
      ".tabs-component__tabs-list": {
        padding: 0
      },
      "p+p": {
        marginTop: "1.8rem"
      },
      ".tabs-component__tab-panel": {
        display: "flex",
        gap: "9.5rem"
      }
    },
    fragmentArray: dataArray.map(item => {
      return {
        children: /*#__PURE__*/_react.default.createElement(Dial, {
          salary: salary,
          customStyles: customDial,
          customTheme: customTheme
        }),
        customId: (0, _string.isStringOfLength)(item.customId) ? item.customId : undefined,
        fragmentId: (0, _string.isStringOfLength)(item.fragmentId) ? item.fragmentId : undefined,
        label: (0, _string.isStringOfLength)(item.label) ? item.label : "Tab 1"
      };
    })
  })));
};

// Define propTypes;
LearnMoreEarnMore.propTypes = {
  /** Array of objects (Default Value: []) */
  dataArray: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    salary: _propTypes.default.string.isRequired,
    fragmentId: _propTypes.default.string.isRequired
  })).isRequired,
  /** Custom dial style object (Default Value: {}) */
  customDial: _propTypes.default.shape({
    background: _propTypes.default.string,
    pointer: _propTypes.default.string,
    segmentOne: _propTypes.default.string,
    segmentTwo: _propTypes.default.string,
    segmentThree: _propTypes.default.string
  }),
  /** Custom salt for tab component */
  customInstanceString: _propTypes.default.string,
  /** Custom styles object (Default Value: {}) */
  customStyles: _propTypes.default.object,
  /** Custom theme object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Test ID String */
  testId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool])
};

// Define propTypes;
Dial.propTypes = {
  customStyles: _propTypes.default.object,
  maxSalary: _propTypes.default.number,
  minSalary: _propTypes.default.number,
  salary: _propTypes.default.string.isRequired,
  testId: _propTypes.default.string,
  timeDelay: _propTypes.default.number
};

// Export component as default;
var _default = exports.default = LearnMoreEarnMore;